import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';
import { getContasReceberKpisTypes } from '../types/getContasReceberKpis';

async function getContasReceberKpis(params): Promise<getContasReceberKpisTypes> {
  const api = await getApi();
  const { data } = await api.get<getContasReceberKpisTypes>('/contas_receber/', {params});
  return data;
}

type QueryFnType = typeof getContasReceberKpis;

function useContasReceberKpis(params) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-contas-receber-kpis', params],
    queryFn: () =>  getContasReceberKpis(params),
  });
}

export { useContasReceberKpis };
